import React from 'react'
import PropTypes from 'prop-types'
import { Text, View } from 'react-native'
import LinearGradient from 'react-native-web-linear-gradient'
import styles, { colors } from '../../styles'

function NoMedicalAdviceFooter(props) {
  const { testID, t, light } = props
  return (
    <>
      <LinearGradient
        style={[styles.scrollGradient, { bottom: 59 }]}
        colors={['rgba(0, 23, 47, 0)', 'rgba(0, 23, 47, .3)', 'rgba(0, 23, 47, 1)']}
        pointerEvents="none"
      />
      <View style={[styles.warningCell, { backgroundColor: light ? colors.actionBlue : colors.bscBlue }]}>
        <Text style={styles.warningCellText} testID={testID}>
          {t('common:noMedAdviceWarning')}
        </Text>
      </View>
    </>
  )
}

NoMedicalAdviceFooter.propTypes = {
  testID: PropTypes.string.isRequired,
  light: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

NoMedicalAdviceFooter.defaultProps = {
  light: false,
}

export default NoMedicalAdviceFooter
